import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default function initSliderTopics() {
    // Selezione degli elementi DOM
    const sliderWrapper = document.querySelector('#posts-slider .swiper-wrapper');
    const switchOptions = document.querySelectorAll('.switch-option');
    const infoCardWrapper = document.querySelector('#info-card');
    let swiperInstance = null;

    // Verifica se il contenitore esiste
    if (!sliderWrapper || !switchOptions) return;

    // Dati delle categorie (passati via PHP come globali)
    const categories = {
        // ✅ TOM: ora topicPosts è atteso come { groups: [], others: [] }
        topic_of_the_month: window.topicPosts || { groups: [], others: [] },
        cover_the_basics: window.basicsPosts || [],
    };

    // Informazioni per la card informativa
    const termsData = window.termsData;

    // =========================
    // Helpers: markup cards
    // =========================

    function buildStandardCard(post, opts = null) {
        const imageUrl = post.image || 'https://via.placeholder.com/300x200?text=No+Image'; // Fallback

        let authorsHtml = '';
        if (post.authors && post.authors.length > 0) {
            authorsHtml = post.authors
                .map(
                    (author) => `
                <a href="${author.url}" class="avatar avatar-circle" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="${author.name}">
                    <img class="avatar-img" src="${author.image}" alt="${author.name}">
                </a>
            `
                )
                .join('');
        }

        const authorsContent = authorsHtml
            ? `
            <h5 class="Authors__title small">Authors</h5>
            <div class="d-flex align-items-center">
                <div class="avatar-group mb-1">
                    ${authorsHtml}
                </div>
            </div>
        `
            : '';

        // ✅ TOM badges (solo se opts è passato)
        const badgesHtml = (opts && (opts.keywordName || opts.installmentNumber))
            ? `
            <div class="Tag Tag__top d-flex gap-2 flex-wrap">
                ${opts.keywordName ? `<span>${opts.keywordName}</span>` : ''} 
            </div>
            `
            : `
            <div class="Tag Tag__top"><a href="${post.category_link}" title="${post.category_name}">${post.category_name}</a></div>
        `;

        return `
        <div class="swiper-slide"> 
            <div class="Card Card__article h-100" data-link="${post.link}">
                <div class="Card__top">
                    ${badgesHtml}
                    <img class="Img Img__top" src="${imageUrl}" alt="${post.title}" loading="lazy">
                </div>
                <div class="Card__bottom">
                    <div class="Card__content">
                        <div class="Card__content--meta">
                            <div class="Card__content--title">${post.title}</div>
                            <div class="Card__content--text mb-0 d-none d-lg-block">${post.excerpt}</div>
                        </div>
                    </div>
                </div>  
                <div class="Authors">
                ${authorsContent}
                </div>         
            </div>
        </div>
    `;
    }

    function getOrdinal(n) {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    // Funzione per renderizzare le card nello slider
    function renderSliderCards(postsOrStructured, isTom = false) {
        sliderWrapper.innerHTML = ''; // Svuota lo slider

        // ✅ TOM: nuova struttura { groups: [], others: [] }
        if (isTom && postsOrStructured && typeof postsOrStructured === 'object' && (postsOrStructured.groups || postsOrStructured.others)) {
            const groups = Array.isArray(postsOrStructured.groups) ? postsOrStructured.groups : [];
            const others = Array.isArray(postsOrStructured.others) ? postsOrStructured.others : [];

            // 1) Gruppi keyword
            groups.forEach((group) => {
                const keywordName = group?.keyword?.name || 'Topic';
                const groupPosts = Array.isArray(group.posts) ? group.posts : [];
                if (groupPosts.length === 0) return;

                groupPosts.forEach((post, index) => {
                    const installmentNumber = index + 1;

                        // altri post → standard (se vuoi, in futuro puoi aggiungere la label anche qui)
                        sliderWrapper.insertAdjacentHTML(
                            'beforeend',
                            buildStandardCard(post, { keywordName, installmentNumber })
                        );

                });
            });

            // 2) Posts senza keyword, standard (DESC)
            /*others.forEach((post) => {
                sliderWrapper.insertAdjacentHTML('beforeend', buildStandardCard(post));
            });*/
        } else {
            // Caso normale (array flat)
            const posts = Array.isArray(postsOrStructured) ? postsOrStructured : [];

            posts.forEach((post) => {
                sliderWrapper.insertAdjacentHTML('beforeend', buildStandardCard(post));
            });
        }

        // Distruggi l'istanza precedente di Swiper (se esiste)
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
        }

        // Inizializza una nuova istanza di Swiper solo per questo slider
        swiperInstance = new Swiper('#posts-slider', {
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: '#Blog-series .rscas-swiper-button-next',
                prevEl: '#Blog-series .rscas-swiper-button-prev',
            },
            spaceBetween: 20,
            loop: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 2,
                },
            },
        });

        // Riporta lo slider alla prima slide
        swiperInstance.slideTo(0, 0);

        // 🔥 Rende cliccabile tutta la card, esclusi i link interni
        const cards = document.querySelectorAll('#Blog-series .Card__article');

        cards.forEach((card) => {
            card.addEventListener('click', (e) => {
                if (e.target.closest('a')) {
                    return;
                }

                const url = card.dataset.link;
                if (url) {
                    window.location.href = url;
                }
            });
        });
    }

    // Funzione per aggiornare la card informativa
    function renderInfoCard(termKey) {
        const term = termsData[termKey];
        infoCardWrapper.innerHTML = `
            <div class="Card Card__info">
                <div class="Card__content h-100">
                    <div class="Card__content--meta d-flex flex-column justify-content-between h-100">
                        <div class="Card__content--cpt card-title">${term.title}</div>
                        <div>
                            <div class="Card__content--text">${term.abstract}</div>
                            <a href="${term.link}" class="btn btn-outline-white">Discover more <i class="fa-sharp fa-regular fa-arrow-right" aria-hidden="true"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    // Gestione del cambio categoria
    function handleSwitchChange(e) {
        const selectedCategory = e.target.dataset.category;

        // Aggiorna visivamente il toggle
        switchOptions.forEach(option => option.classList.remove('active'));
        e.target.classList.add('active');

        // ✅ TOM: passa flag isTom per usare la nuova struttura
        const isTom = selectedCategory === 'topic_of_the_month';

        // Aggiorna slider e info card
        renderSliderCards(categories[selectedCategory], isTom);
        renderInfoCard(selectedCategory);
    }

    // Aggiunge gli event listener al toggle
    switchOptions.forEach(option => {
        option.addEventListener('click', handleSwitchChange);
    });

    // Inizializzazione con "Topic of the Month"
    renderSliderCards(categories['topic_of_the_month'], true); // ✅ TOM flag
    renderInfoCard('topic_of_the_month');
}
